import { getLoginRedirectUrlFromQueryParam } from '../routing/getLoginRedirectUrlFromQueryParam';
export default function getAppFromLoginRedirectUrl() {
  const loginRedirectUrl = getLoginRedirectUrlFromQueryParam();

  if (loginRedirectUrl) {
    const clientId = loginRedirectUrl.searchParams.get('client_id');
    return clientId;
  }

  return null;
}